import React, { useState, useEffect } from 'react'

import { CurrencyList, PurchaseLot, Country } from '../../../../../types'
import NumberFormat from '../../../../../../components/DashboardCharts/NumberFormat'

type Props = {
    purchaseGuid: string
    purchaseAction: boolean
    purch_number: number
    purchaseLot: PurchaseLot
    theme: string
    isActive: boolean
    currencyList: CurrencyList[]
    selected: boolean
    onDoubleClick: (purch_lot_guid: string) => void
}

const PERFORMANCE_STATUS = new Map([
    ['F', 'Редактирование'],
    ['P', 'Размещено'],
    ['I', 'Недействительно'],
    ['M', 'Изменение'],
])

const PurchaseLotTableRow: React.FC<Props> = (props) => {
    return (
        <div
            className={
                props.selected
                    ? 'plan-position-table-row-selected'
                    : 'plan-position-table-row'
            }
            onDoubleClick={() => props.onDoubleClick(props.purchaseLot.guid)}
        >
            <div className="flex h-[70px] w-8 items-center justify-center text-center">
                {props.purchaseAction ? (
                    ''
                ) : (
                    <input
                        type="checkbox"
                        checked={props.selected}
                        onClick={(e) => e.stopPropagation()}
                    />
                )}
            </div>
            <div className="flex flex-row h-[70px] w-8 items-center justify-center text-center ">
                {props.purch_number}
            </div>

            <div className="flex flex-1 h-[70px] text-left items-center justify-start">
                {`Лот № ${props.purchaseLot.ordinal_number ? props.purchaseLot.ordinal_number : '-'} "${props.purchaseLot.subject ? props.purchaseLot.subject : '-'}"`}
            </div>
            <div className="flex w-28 items-center justify-center text-center">
                <NumberFormat
                    value={Number(
                        props.purchaseLot.initial_sum ||
                            props.purchaseLot.max_contract_price
                    )}
                />
            </div>
        </div>
    )
}

export default PurchaseLotTableRow
